(function () {
  const STATE_ZONE = {
    SC: 1,
    NC: 2,
    GA: 2,
    VA: 3,
    TN: 3,
    FL: 3,
    AL: 3,
    MS: 4,
    KY: 4,
    WV: 4,
    MD: 4,
    DE: 4,
    DC: 4,
    PA: 5,
    NJ: 5,
    NY: 5,
    CT: 5,
    RI: 5,
    MA: 5,
    VT: 5,
    NH: 5,
    ME: 5,
    OH: 5,
    IN: 5,
    IL: 5,
    MI: 5,
    WI: 5,
    MN: 5,
    IA: 5,
    MO: 5,
    AR: 5,
    LA: 5,
    TX: 6,
    OK: 6,
    KS: 6,
    NE: 6,
    SD: 6,
    ND: 6,
    CO: 7,
    NM: 7,
    MT: 7,
    WY: 7,
    AZ: 7,
    UT: 7,
    NV: 7,
    ID: 7,
    CA: 8,
    OR: 8,
    WA: 8,
    AK: 9,
    HI: 9,
    PR: 9,
    VI: 9,
    GU: 9,
  };

  const ZIP3_STATE = [
    [5, 5, 'NY'], [6, 9, 'NY'], [10, 27, 'MA'], [28, 29, 'RI'], [30, 38, 'NH'],
    [39, 49, 'ME'], [50, 59, 'VT'], [60, 69, 'CT'], [70, 89, 'NJ'], [100, 149, 'NY'],
    [150, 196, 'PA'], [197, 199, 'DE'], [200, 205, 'DC'], [206, 219, 'MD'], [220, 246, 'VA'],
    [247, 269, 'WV'], [270, 289, 'NC'], [290, 299, 'SC'], [300, 319, 'GA'], [320, 349, 'FL'],
    [350, 369, 'AL'], [370, 385, 'TN'], [386, 397, 'MS'], [400, 427, 'KY'], [430, 459, 'OH'],
    [460, 479, 'IN'], [480, 499, 'MI'], [500, 528, 'IA'], [530, 549, 'WI'], [550, 567, 'MN'],
    [570, 577, 'SD'], [580, 588, 'ND'], [590, 599, 'MT'], [600, 629, 'IL'], [630, 658, 'MO'],
    [660, 679, 'KS'], [680, 693, 'NE'], [700, 714, 'LA'], [716, 729, 'AR'], [730, 749, 'OK'],
    [750, 799, 'TX'], [800, 816, 'CO'], [820, 831, 'WY'], [832, 838, 'ID'], [840, 847, 'UT'],
    [850, 865, 'AZ'], [870, 884, 'NM'], [889, 898, 'NV'], [900, 961, 'CA'], [967, 968, 'HI'],
    [970, 979, 'OR'], [980, 994, 'WA'], [995, 999, 'AK'],
  ];

  let ratesData = null;
  let loadPromise = null;

  function zipToState(zip) {
    const clean = String(zip || '').replace(/\D/g, '').slice(0, 5);
    if (clean.length < 3) return '';
    const prefix = parseInt(clean.slice(0, 3), 10);
    for (const [min, max, state] of ZIP3_STATE) {
      if (prefix >= min && prefix <= max) return state;
    }
    return '';
  }

  function zoneKeyFromZip(zip) {
    const state = zipToState(zip);
    const zone = STATE_ZONE[state] || 5;
    return `zone${zone}`;
  }

  function lookupRate(totalOz, zoneKey) {
    if (!ratesData?.groundAdvantage) return null;
    const ga = ratesData.groundAdvantage;
    if (totalOz <= 15.999) {
      const tier = ga.ounces.find((t) => totalOz <= t.maxOunces) || ga.ounces[ga.ounces.length - 1];
      return tier.rates[zoneKey] || tier.rates.zone5;
    }
    const pounds = Math.ceil(totalOz / 16);
    const tier = ga.pounds.find((t) => pounds <= t.maxPounds) || ga.pounds[ga.pounds.length - 1];
    return tier.rates[zoneKey] || tier.rates.zone5;
  }

  /**
   * One package per order. Billable ounces = sum of item packaged weights.
   * Extra items add product weight only (same box/mailer).
   */
  function estimateShipment(items, zoneKey) {
    const list = items || [];
    const totalItems = list.reduce((sum, item) => sum + Math.max(1, parseInt(item.quantity, 10) || 1), 0);
    if (!totalItems) {
      return { packages: 0, total: 0, zoneKey, tier: null, itemCount: 0 };
    }

    const billableOz = list.reduce((sum, item) => {
      const qty = Math.max(1, parseInt(item.quantity, 10) || 1);
      const oz = Number(item.weightOz) > 0 ? Number(item.weightOz) : 8;
      return sum + oz * qty;
    }, 0);

    const cost = lookupRate(billableOz, zoneKey);
    if (cost == null || Number.isNaN(cost)) {
      return { packages: 0, total: 0, zoneKey, tier: null, itemCount: totalItems };
    }

    return {
      packages: 1,
      total: Math.round(cost * 100) / 100,
      zoneKey,
      tier: billableOz <= 15.999 ? `${billableOz}oz` : `${Math.ceil(billableOz / 16)}lb`,
      itemCount: totalItems,
      billableOz,
    };
  }

  function ratesUrl() {
    return window.ProtoForgeShipping?.ratesUrl
      || document.querySelector('[data-shipping-rates-url]')?.dataset.shippingRatesUrl
      || '';
  }

  async function loadData() {
    if (ratesData) return ratesData;
    if (loadPromise) return loadPromise;

    loadPromise = (async () => {
      const url = ratesUrl();
      if (!url) throw new Error('Missing USPS rates URL');
      const ratesRes = await fetch(url);
      if (!ratesRes.ok) throw new Error(`Failed to load rates (${ratesRes.status})`);
      ratesData = await ratesRes.json();
      if (!ratesData?.groundAdvantage) throw new Error('Invalid rates data');
      return ratesData;
    })().catch((err) => {
      loadPromise = null;
      throw err;
    });

    return loadPromise;
  }

  function formatMoney(amount) {
    return `$${Number(amount).toFixed(2)}`;
  }

  function cleanZip(zip) {
    return String(zip || '').replace(/\D/g, '').slice(0, 5);
  }

  async function initProductShipping() {
    const root = document.querySelector('[data-shipping-estimate]');
    if (!root) return;

    const productType = root.dataset.productType || '';
    const grams = parseFloat(root.dataset.variantWeightGrams || '0');
    const weightOz = grams > 0 ? grams / 28.3495 : 0;
    const zipInput = root.querySelector('[data-shipping-zip]');
    const qtyInput = document.getElementById('Quantity')
      || root.closest('[data-product-page], .product-page, form')?.querySelector('[name="quantity"], #Quantity, [data-clock-qty]');
    const valueEl = root.querySelector('[data-shipping-value]');
    const detailEl = root.querySelector('[data-shipping-detail]');
    if (!valueEl) return;

    try {
      await loadData();
    } catch (err) {
      console.error('Shipping estimate rates failed to load', err);
      valueEl.textContent = 'Shipping estimate unavailable';
      if (detailEl) detailEl.textContent = 'Please try again or contact us for a shipping quote.';
      return;
    }

    function render() {
      const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
      const zipDigits = cleanZip(zipInput?.value || '');
      const zoneKey = zipDigits.length >= 3 ? zoneKeyFromZip(zipDigits) : 'zone5';
      const shipmentItems = [{ type: productType, quantity: qty, weightOz }];
      const result = estimateShipment(shipmentItems, zoneKey);

      if (!result.total) {
        valueEl.textContent = 'Contact us for a shipping quote';
        if (detailEl) detailEl.textContent = '';
        return;
      }

      const zoneNum = zoneKey.replace('zone', '');
      if (zipDigits.length >= 5) {
        valueEl.textContent = `${formatMoney(result.total)} estimated (Zone ${zoneNum})`;
        if (detailEl) {
          detailEl.textContent = 'USPS Ground Advantage commercial rate from Lexington, SC.';
        }
      } else if (zipDigits.length >= 3) {
        valueEl.textContent = `${formatMoney(result.total)} estimated (Zone ${zoneNum})`;
        if (detailEl) {
          detailEl.textContent = 'Enter full 5-digit ZIP for a closer zone estimate.';
        }
      } else {
        const low = estimateShipment(shipmentItems, 'zone1').total;
        const high = estimateShipment(shipmentItems, 'zone8').total;
        valueEl.textContent = `${formatMoney(low)} – ${formatMoney(high)} estimated`;
        if (detailEl) {
          detailEl.textContent = 'Enter ZIP for a closer estimate.';
        }
      }
    }

    zipInput?.addEventListener('input', render);
    zipInput?.addEventListener('change', render);
    qtyInput?.addEventListener('input', render);
    qtyInput?.addEventListener('change', render);
    render();
  }

  // Preserve ratesUrl / profilesUrl set by the Liquid snippet before this file runs.
  window.ProtoForgeShipping = Object.assign(window.ProtoForgeShipping || {}, {
    loadData,
    estimateShipment,
    zoneKeyFromZip,
    initProductShipping,
  });

  function boot() {
    initProductShipping();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
